import { render, staticRenderFns } from "./questiontype.vue?vue&type=template&id=7a47919c&"
import script from "./questiontype.vue?vue&type=script&lang=js&"
export * from "./questiontype.vue?vue&type=script&lang=js&"
import style0 from "./questiontype.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports